import { MatDialogRef } from '@angular/material/dialog';

export interface FeatureState {
  ref: MatDialogRef<any> | null;
}

export const initialState: FeatureState = {
  ref: null,
};
